import { Modal, ModalWrapper } from '@braskai/ui-kit';

import { useInterfaceLanguage } from '@/shared/i18n';
import { ModalHeaderWithIcon } from '@/shared/ui/modal';

import { useEnterprisePaymentRequiredModalStore } from '../../model/useEnterprisePaymentRequiredModalStore';

const EnterprisePaymentRequiredModalComponent = () => {
  const { t } = useInterfaceLanguage();
  const { close } = useEnterprisePaymentRequiredModalStore();

  return (
    <Modal size="xs" open onClose={close}>
      <ModalHeaderWithIcon
        title={t('pricing.enterprisePayment.unknownError')}
        subtitle={
          <span>
            {t('pricing.enterprisePayment.contactSupport')} <a href="mailto:support@rask.ai">support@rask.ai</a>.
          </span>
        }
        iconType="error"
        onClose={close}
      />
    </Modal>
  );
};

export const EnterprisePaymentRequiredModal = () => (
  <ModalWrapper hook={useEnterprisePaymentRequiredModalStore}>
    <EnterprisePaymentRequiredModalComponent />
  </ModalWrapper>
);
